// extracted by mini-css-extract-plugin
module.exports = {"ProjectOverview":"ProjectOverview_ProjectOverview__DoLlq","wrapper":"ProjectOverview_wrapper__3h8z9"};